import gsap from "gsap";

export default function() {

  gsap.set(".js-nda-nav01", { opacity: 0 });
  gsap.set(".js-nda-nav02", { opacity: 0 });
  gsap.set(".js-nda-nav03", { opacity: 0 });
  gsap.set(".js-nda-nav04", { opacity: 0 });
  gsap.set(".js-nda-nav05", { opacity: 0 });
  gsap.set(".js-nda-nav06", { opacity: 0 });

  const targetMain = document.querySelector(".topNavigation__main");
  const targetSub = document.querySelector(".topNavigation__sub");

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.2
  };

  const callbackMain = function(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      displayMain();
    });
  };

  const callbackSub = function(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      displaySub();
    });
  };

  const observerMain = new IntersectionObserver(callbackMain, options);
  const observerSub = new IntersectionObserver(callbackSub, options);

  observerMain.observe(targetMain);
  observerSub.observe(targetSub);

  function displayMain() {

    gsap.to(".js-nda-nav01", {
      opacity: 1,
      duration: 3,
      ease: "power4.out"
    });

    gsap.to(".js-nda-nav02", {
      delay: 0.3,
      opacity: 1,
      duration: 3,
      ease: "power4.out"
    });

    gsap.to(".js-nda-nav03", {
      delay: 0.6,
      opacity: 1,
      duration: 3,
      ease: "power4.out"
    });
  }

  function displaySub() {

    gsap.to(".js-nda-nav04", {
      opacity: 1,
      duration: 3,
      ease: "power4.out"
    });

    gsap.to(".js-nda-nav05", {
      delay: 0.3,
      opacity: 1,
      duration: 3,
      ease: "power4.out"
    });

    gsap.to(".js-nda-nav06", {
      delay: 0.6,
      opacity: 1,
      duration: 3,
      ease: "power4.out"
    });
  }
}
